<template>
  <footer class="footer" id="footer">
    <div class="container">
      <!-- Connect with us -->
      <div class="connect-box">
        <p class="connect-title">Get more info / Learn more:</p>
        <ul class="social-list">
          <li>
            <a href="https://www.facebook.com/anovator.global" target="_blank" rel="noopener" aria-label="Facebook" class="social-item">
              <img class="social-icon" src="/static/images/facebook@2x.png" alt="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/anovator.global/" target="_blank" rel="noopener" aria-label="Instagram" class="social-item">
              <img class="social-icon" src="/static/images/instagram@2x.png" alt="Instagram" />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/anovator/" target="_blank" rel="noopener" aria-label="LinkedIn" class="social-item">
              <img class="social-icon" src="/static/images/Linkedin@2x.png" alt="LinkedIn" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@anovator" target="_blank" rel="noopener" aria-label="YouTube" class="social-item">
              <img class="social-icon" src="/static/images/Youtube@2x.png" alt="YouTube" />
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@anovator_global" target="_blank" rel="noopener" aria-label="TikTok" class="social-item tiktok-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
              </svg>
            </a>
          </li>
        </ul>
      </div>

      <!-- Policy links -->
      <div class="footer-links">
        <ul class="policy-list">
          <li>
            <router-link to="/privacy-policy">Privacy Policy</router-link>
          </li>
          <li>
            <router-link to="/refund-policy">Refund Policy</router-link>
          </li>
          <li>
            <router-link to="/shipping-policy">Shipping Policy</router-link>
          </li>
          <li>
            <router-link to="/terms-of-service">Terms Of Service</router-link>
          </li>
          <li>
            <a href="/legal/GDPR-FORM-05-1-Data-Subject-Request-Form.pdf" target="_blank" rel="noopener noreferrer">Data Subject Request Form</a>
          </li>
          <li>
            <button type="button" class="cookie-settings" data-anovator-cookie-settings>Cookie Settings</button>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      showBackToTop: false
    }
  },
  mounted() {
    this.initBackToTop()
    this.loadImages()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    initBackToTop() {
      window.addEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300
    },
    loadImages() {
      // Vue实现的图片懒加载
      const imgs = document.querySelectorAll('img[data-src]')
      imgs.forEach((item) => {
        if (item.dataset.src && item.dataset.src !== '') {
          item.src = item.dataset.src
          item.removeAttribute('data-src')
        }
      })
    }
  }
}
</script>

<style scoped>
.footer {
  background: #000;
  padding: 36px 0 28px;
  color: #fff;
}

.connect-title {
  text-align: center;
  margin: 0 0 16px;
  font-weight: 600;
  color: #fff;
}

.social-list {
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  display: flex;
  justify-content: center;
  gap: 24px;
}

.social-item {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  color: #fff;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.social-item:hover {
  transform: translateY(-2px);
  border-color: #fff;
}

.social-item img, .social-icon {
  width: 100%;
  height: 100%;
}

.footer-links {
  text-align: center;
}

.policy-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: flex;
  justify-content: center;
  gap: 40px;
}

.policy-list a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 12px;
}

.cookie-settings {
  padding: 0;
  color: rgba(255, 255, 255, 0.7);
  background: transparent;
  border: 0;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.cookie-settings:hover,
.cookie-settings:focus-visible {
  color: #fff;
}

.policy-list a:hover {
  color: #fff;
}

.tiktok-item {
  color: #FFFFFF;
  border: 1.5px solid #2b2a2a;
}
.tiktok-item:hover {
  border: 1px solid #2b2a2a;
}


@media (max-width: 768px) {
  .social-item { width: 40px; height: 40px; }
  .policy-list { gap: 20px; flex-wrap: wrap; }
}
</style>
